import React from "react";
import { Link } from "react-router-dom";
import { InvoicePrintType } from "../../types/users/UserTypes";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";

const InvoiceButtons: React.FC<InvoicePrintType> = ({ handlePrint }) => {
  const { t } = useTranslation();

  return (
    <span
      style={{ display: "flex", justifyContent: "flex-end", gap: 15 }}
      className="mb-3"
    >
      <Link onClick={handlePrint} to="">
        <Button color="secondary" outline className="me-2">
          {t("Print Invoice")}
          <i
            className="icon-arrow-right"
            style={{ fontSize: 13, fontWeight: "bold", marginLeft: 10 }}
          />
        </Button>
      </Link>
    </span>
  );
};

export default InvoiceButtons;
